module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "centered": "",
      "title": _vm.modalData.title,
      "header-bg-variant": _vm.modalData.headerBgVariant,
      "header-text-variant": _vm.modalData.headerTextVariant,
      "body-bg-variant": _vm.bodyBgVariant,
      "body-text-variant": _vm.bodyTextVariant,
      "footer-bg-variant": _vm.footerBgVariant,
      "footer-text-variant": _vm.footerTextVariant
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function() {
        return [_vm._t("footer")]
      },
      proxy: true
    }], null, true),
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.modalData.msg) + "\n  ")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-5fd8d7e8!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TipModal.vue
// module id = Jkz5
// module chunks = 4